import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import Home from 'components/Home'
import { OptionsHOC } from 'hocs'
import { useKendra } from '../../hooks'
import { arrayMoveImmutable } from 'array-move'
import { updateTitle } from '../Breadcrumbs/actions'
import { updateLayout } from './actions'
import { selectLayout } from './selectors'
import { selectUser } from '../App/selectors'

const HomeContainer = (props) => {
  const { isKendraEnabled } = useKendra()

  useEffect(() => {
    props.updateTitle('Home Page')
  }, [props.updateTitle])

  const onSortEnd = useCallback(({ oldIndex, newIndex }) => {

    if (isKendraEnabled) {
      const launchIndex = props.items.indexOf('launch');
      const bulletinIndex = props.items.indexOf('bulletin');
      if (launchIndex === -1 || bulletinIndex === -1) {
        return;
      }
      const displayedItems = props.items.filter(item => item === 'launch' || item === 'bulletin');
      // Move the displayed items according to drag-and-drop indices
      const updatedDisplayedItems = arrayMoveImmutable(displayedItems, oldIndex, newIndex);
      // Create a copy of the items array to update
      const updatedItems = [...props.items];
      // Replace the displayed items in their original positions with the new order
      let displayedIdx = 0;
      for (let i = 0; i < updatedItems.length; i++) {
        if (updatedItems[i] === 'launch' || updatedItems[i] === 'bulletin') {
          updatedItems[i] = updatedDisplayedItems[displayedIdx];
          displayedIdx++;
        }
      }
      props.updateLayout(updatedItems);
    } else {
      props.updateLayout(arrayMoveImmutable(props.items, oldIndex, newIndex));
    }
  }, [props.updateLayout, props.items, isKendraEnabled]);

  const generateProps = () => ({
    ...props,
    onSortEnd,
    isKendraEnabled,
    axis: 'xy',
    distance: 10,
    helperClass: 'sortable-item',
    useDragHandle: true
  })

  return <Home {...generateProps()} />

}

const mapStateToProps = state => ({
  items: selectLayout(state),
  user: selectUser(state)
})

const mapDispatchToProps = dispatch => ({
  updateTitle: title => dispatch(updateTitle(title)),
  updateLayout: layout => dispatch(updateLayout(layout))
})

const ConnectedHomeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(
  HomeContainer
))

export default ConnectedHomeContainer
